var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('NotificationList'),_c('div',{staticClass:"app-wrap"},[_c('HeaderComponent',{on:{"connectWallet":function($event){return _vm.setWalletOption()}}}),_c('router-view',{on:{"connectWallet":function($event){return _vm.setWalletOption()}}})],1),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }